import store from "../vuex/store";
import moment from "moment";
// type:1 是年月日(不带时分秒)；2 是年月日，时分秒;3是时分秒;4是年月;5是年;6时分;7年月日时分;   changeType: 1是将时间转换为GMT+8(上传数据使用),2是从GMT+8转换为当前时区(展示时使用),3是电脑时区转换为项目选中时区.   day加减天数
function timeChange1(value, type = 2, changeType = 1, shiqu = store.areaCode?parseInt(store.areaCode):8,days = 0) {
    if(!value){
        return null;
    }
    if(typeof(value)=="string"){
        value = value.replace(/-/g,"/");
    }
    value = Date.parse(new Date(value));
    if(changeType == 3){
        var sq = new Date().getTimezoneOffset() / -60;
        value = value + (shiqu - sq) * 3600000;
    }else if(changeType == 1){
        value = value + (8 - shiqu) * 3600000;
    }else if(changeType == 2){
        value = value + (shiqu - 8) * 3600000;
    }
    // new Date(new Date('2021.10.30').setDate(new Date('2021.10.30').getDate()+2))
    var str = '';
    if (type == 1 || type == 2 || type == 4|| type == 5) {
        var oldTime = new Date(value);
        time = new Date(oldTime.setDate(oldTime.getDate()+days))
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (date < 10) {
            date = "0" + date;
        }
        str = year + "-" + month + "-" + date;
        if(type == 4){
            str = year + "-" + month;
        }
        if(type == 5){
            str = year;
        }
    }

    if (type == 2 || type == 3) {
        var time = new Date(value);
        var h = time.getHours();
        var m = time.getMinutes();
        var s = time.getSeconds();
        if (h < 10) {
            h = "0" + h;
        }
        if (m < 10) {
            m = "0" + m;
        }
        if (s < 10) {
            s = "0" + s;
        }
        if (type == 2) {
            str = str + " ";
        }
        str = str + h + ":" + m + ":" + s;
    }
    return str;
}
function timeChange(value, type = 2, changeType = 1, shiqu = store.getters.areaCodeString,days = 0) {
    var newDate = ''
    var format = 'YYYY-MM-DD'
    if(type == 2){
        format = 'YYYY-MM-DD HH:mm:ss'
    }else if(type == 3){
        format = 'HH:mm:ss'
    }else if(type == 4){
        format = 'YYYY-MM'
    }else if(type == 5){
        format = 'YYYY'
    }else if(type == 6){
        format = 'HH:mm'
    }else if(type == 7){
        format = 'YYYY-MM-DD HH:mm'
    }else{
        format = 'YYYY-MM-DD'
    }
    
    var beijing = moment(new Date(value)).tz('Asia/Shanghai');//北京时间
    var computer = moment(new Date(value)).tz(moment.tz.guess());//电脑时间

    //days天数为正数表示增加天数,负数表示减少天数
    if(days<0){
        if(changeType==1){//1是将时间转换为GMT+8(上传数据使用)
            newDate = beijing.subtract(Math.abs(days),'days').format(format)
        }else if(changeType==2){//2是从GMT+8转换为当前选中时区(展示时使用)
            newDate = beijing.clone().tz(shiqu).subtract(Math.abs(days),'days').format(format)
        }else{//3是电脑时区转换为当前选中时区
            newDate = computer.clone().tz(shiqu).subtract(Math.abs(days),'days').format(format)
        }
    }else if(days>0){
        if(changeType==1){
            newDate = beijing.add(Math.abs(days),'days').format(format)
        }else if(changeType==2){
            newDate = beijing.clone().tz(shiqu).add(Math.abs(days),'days').format(format)
        }else{
            newDate = computer.clone().tz(shiqu).add(Math.abs(days),'days').format(format)
        }
    }else{
        if(changeType==1){
            newDate = moment(new Date(value)).tz('Asia/Shanghai').format(format);
        }else if(changeType==2){
            newDate = beijing.clone().tz(shiqu).format(format)
        }else{
            newDate = computer.clone().tz(shiqu).format(format)
        }
    }

    return newDate;
}

export default timeChange




// WEBPACK FOOTER //
// ./src/utils/time.js